import { UpsellBannerContent } from '../components/UpsellBanner';
import {
    newMicrosoftMesssage,
    browseSmarterMessage,
    speedPerformanceMessage,
    expectMoreMessage,
    recommendedBrowserMessage,
    ubTryItNowLinkText,
    ubDownloadNowLinkText,
    ubLetsGoLinkText,
    ubDownloadEdgeLinkText,
} from '../components/EdgeUpsellStrings.locstring.json';
import loc from 'owa-localize';

export const spartanStrings: UpsellBannerContent[] = [
    {
        contentId: 'MY01CA',
        contentMessage: loc(newMicrosoftMesssage),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01CA&OCID=MY01CA',
    },
    {
        contentId: 'MY01DK',
        contentMessage: loc(expectMoreMessage),
        contentLinkButtonText: loc(ubDownloadEdgeLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01DK&OCID=MY01DK',
    },
    {
        contentId: 'MY01DL',
        contentMessage: loc(recommendedBrowserMessage),
        contentLinkButtonText: loc(ubDownloadEdgeLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01DL&OCID=MY01DL',
    },
    {
        contentId: 'MY01EC',
        contentMessage: loc(recommendedBrowserMessage),
        contentLinkButtonText: loc(ubTryItNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01EC&OCID=MY01EC',
    },
    {
        contentId: 'MY01ED',
        contentMessage: loc(recommendedBrowserMessage),
        contentLinkButtonText: loc(ubLetsGoLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01ED&OCID=MY01ED',
    },
    {
        contentId: 'MY01EE',
        contentMessage: loc(recommendedBrowserMessage),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01EE&OCID=MY01EE',
    },
    {
        contentId: 'MY01EG',
        contentMessage: loc(speedPerformanceMessage),
        contentLinkButtonText: loc(ubDownloadEdgeLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01EG&OCID=MY01EG',
    },
    {
        contentId: 'MY01EI',
        contentMessage: loc(speedPerformanceMessage),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01EI&OCID=MY01EI',
    },
    {
        contentId: 'MY01EL',
        contentMessage: loc(browseSmarterMessage),
        contentLinkButtonText: loc(ubDownloadNowLinkText),
        contentLinkHref: 'https://www.microsoft.com/edge?form=MY01EL&OCID=MY01EL',
    },
];
